import React from 'react';
import { Bell, BellRing } from 'lucide-react';
import NotificationsPreferences from '../components/notifications/NotificationsPreferences';
import PushNotificationToggle from '../components/notifications/PushNotificationToggle';
import PageBackButton from '../components/PageBackButton';

function NotificationSettingsContent() {
  return (
    <div className="w-full min-w-0 max-w-3xl p-3 sm:p-4 md:p-6 lg:p-8">
      {/* Header */}
      <div className="mb-5 flex min-w-0 items-center gap-2 sm:mb-6 sm:gap-3">
        <PageBackButton label="Back to Settings" to="/settings" preferHistory={false} hideLabelOnMobile />
        <Bell className="h-5 w-5 shrink-0 text-primary sm:h-6 sm:w-6" />
        <h1 className="min-w-0 text-lg font-bold leading-tight text-textPrimary sm:text-2xl md:text-3xl">
          Notification Settings
        </h1>
      </div>

      {/* Push Notifications */}
      <div className="mb-5 min-w-0 rounded-xl border border-borderDefault bg-backgroundSurface p-4 shadow-sm sm:mb-6 sm:p-6">
        <div className="flex items-center gap-2 mb-4">
          <BellRing className="w-5 h-5 text-primary" />
          <h2 className="text-lg font-semibold text-textPrimary">Push Notifications</h2>
        </div>
        <p className="text-sm text-textSecondary mb-4">
          Receive notifications even when the app is in the background or closed.
          Your browser will ask for permission when you enable this.
        </p>
        <PushNotificationToggle />
      </div>

      {/* Per-category preferences */}
      <div className="min-w-0 rounded-xl border border-borderDefault bg-backgroundSurface p-4 shadow-sm sm:p-6">
        <div className="flex items-center gap-2 mb-4">
          <Bell className="w-5 h-5 text-primary" />
          <h2 className="text-lg font-semibold text-textPrimary">Category Preferences</h2>
        </div>
        <p className="text-sm text-textSecondary mb-4">
          Control which notification categories you receive and their minimum severity level.
        </p>
        <NotificationsPreferences />
      </div>
    </div>
  );
}

export default function NotificationSettingsPage() {
  return <NotificationSettingsContent />;
}
